function parseMmDdYyyyDate(value) {
    const trimmed = String(value || '').trim();
    const match = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) {
        return null;
    }
    const month = parseInt(match[1], 10);
    const day = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return null;
    }
    return date;
}

function calendarDayStart(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

function pledgeScheduleStartDateIsNotFuture(value) {
    const date = parseMmDdYyyyDate(value);
    if (date === null) {
        return false;
    }
    return calendarDayStart(date) <= calendarDayStart(new Date());
}

function isPledgeScheduleStartCalendarDateEnabled(date) {
    return calendarDayStart(date) > calendarDayStart(new Date());
}

function pledgeScheduleStartBeforeShowDay(date) {
    const enabled = isPledgeScheduleStartCalendarDateEnabled(date);
    if ($.fn.datepicker && $.fn.datepicker.Constructor) {
        return enabled;
    }
    return [enabled];
}

function pledgeScheduleStartDatepickerOptions() {
    return {
        autoclose: true,
        todayHighlight: false,
        format: 'mm/dd/yyyy',
        forceParse: false,
        beforeShowDay: pledgeScheduleStartBeforeShowDay,
        clearBtn: true,
        orientation: 'top',
    };
}

function pledgeScheduleStartDatepickerWidget($root) {
    const $input = $root.find('input[name="pledge_start_date"]').first();
    if (!$input.length) {
        return $();
    }
    const $widget = $input.closest('.input-group.date');
    return $widget.length ? $widget : $input;
}

function initPledgeScheduleStartDatepicker($root) {
    const $widget = pledgeScheduleStartDatepickerWidget($root);
    if (!$widget.length || typeof $widget.datepicker !== 'function') {
        return;
    }
    if ($widget.data('datepicker')) {
        $widget.datepicker('destroy');
    }
    $widget.removeClass('hasDatepicker');
    $widget.datepicker(pledgeScheduleStartDatepickerOptions());
}

function pledgeScheduleStartNotFutureMessage() {
    return 'Schedule start date cannot be today or in the past. Choose a later date.';
}

function blockPledgeScheduleStartDateIfNotFuture($root) {
    const $input = $root.find('input[name="pledge_start_date"]');
    if (!$input.length || $input.prop('disabled')) {
        return false;
    }
    return pledgeScheduleStartDateIsNotFuture($input.val());
}

let documentHandlersBound = false;

function bindPledgeScheduleStartDateDocumentHandlers() {
    if (documentHandlersBound) {
        return;
    }
    documentHandlersBound = true;

    $(document).on('input', 'input[name="pledge_start_date"]', function () {
        $(this).data('pledgeScheduleStartLastTyped', $(this).val());
    });

    $(document).on('change', 'input[name="pledge_start_date"]', function () {
        const $input = $(this);
        const lastTyped = $input.data('pledgeScheduleStartLastTyped');
        if (!parseMmDdYyyyDate($input.val()) && pledgeScheduleStartDateIsNotFuture(lastTyped)) {
            $input.val(lastTyped);
        }
    });
}

bindPledgeScheduleStartDateDocumentHandlers();

export {
    blockPledgeScheduleStartDateIfNotFuture,
    initPledgeScheduleStartDatepicker,
    pledgeScheduleStartDateIsNotFuture,
    pledgeScheduleStartDatepickerWidget,
    pledgeScheduleStartNotFutureMessage,
};
